<template>
	<div style="text-align: center">
		<img alt="xiaoyanyun" class="zui-logo" :src="src" @click="onClick" />
		<div class="logo_name">{{name}}</div>
	</div>
</template>
<script>
	import './less/logo.css'
	import logo from './img/logo.png'
	import zlogo from './img/one.png'
	import hrLogo from './img/two.png'
	import plusLogo from './img/three.png'
	import fourLogo from './img/four.png'

	import wanLogo1 from './img/wan-one.png'
	import wanLogo2 from './img/wan-two.png'
	import wanLogo3 from './img/wan-three.png'

	import footer1 from './img/footer1.png'
	import footer2 from './img/footer2.png'
	import footer3 from './img/footer3.png'
	import footer4 from './img/footer4.png'
	import footer5 from './img/footer5.png'
	import footerlogo1 from './img/footerlogo1.jpg'
	import footerlogo2 from './img/footerlogo2.jpg'
	import footerlogo3 from './img/footerlogo3.png'
	export default {
		name: 'Logo',
		props: {
			type: {
				type: [String, Number],
				default: 'xiaoyanyun'
			},
			href: {
				default: '/'
			},
			name: {
				default: ''
			},
			width: {
				default: '150px'
			},
			height: {
				default: '52px'
			}
		},
		computed: {
			src: function() {
				if (this.type === 'xiaoyanyun') {
					return logo
				}
				if (this.type == 1) {
					return zlogo
				}
				if (this.type == 4) {
					return fourLogo
				}
				if (this.type == 2) {
					return hrLogo
				}
				if (this.type == 3) {
					return plusLogo
				}
				if (this.type === 'wan1') {
					return wanLogo1
				}
				if (this.type === 'wan2') {
					return wanLogo2
				}
				if (this.type === 'wan3') {
					return wanLogo3
				}
				if (this.type === 'footer1') {
					return footer1
				}
				if (this.type === 'footer2') {
					return footer2
				}
				if (this.type === 'footer3') {
					return footer3
				}
				if (this.type === 'footer4') {
					return footer4
				}
				if (this.type === 'footer5') {
					return footer5
				}
				if (this.type === 'footerlogo1') {
					return footerlogo1
				}
				if (this.type === 'footerlogo2') {
					return footerlogo2
				}
				if (this.type === 'footerlogo3') {
					return footerlogo3
				}

			}
		},
		methods: {
			onClick: function(e) {
				if (this.type === "xiaoyanyun") {
					location.assign(this.href)
				}

				/*if (this.type === 'footerlogo1') {
					this.showPicture(footerlogo1)
				}
				if (this.type === 'footerlogo2') {
					this.showPicture(footerlogo2)
				}
				if (this.type === 'footerlogo3') {
					this.showPicture(footerlogo3)
				}*/
			},

			//点击查看大图
			showPicture(src) {
				this.$viewerApi({
					images: src ? [src] : this.images,
					options: {
						inline: false,
						button: true,
						navbar: false,
						title: false,
						toolbar: false,
						tooltip: false,
						movable: false,
						zoomable: false,
						rotatable: false,
						scalable: false,
						transition: false,
						fullscreen: true,
						keyboard: true,
					}
				})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Logo.vue